export default "__VITE_ASSET__d98269eb__"